import dynamic from 'next/dynamic'
import Head from 'next/head'

const CreateUserEvent = dynamic(() => import('../../components/CreateUserEvent'), {
  ssr: false
})

const Routes = () => {
  return (
    <>
      <Head>
        <title>Create Event – DecorMatters</title>
      </Head>
      <CreateUserEvent />
    </>
  )
}

export default Routes
